export default "__VITE_ASSET__CZMZ8mdf__"